// extracted by mini-css-extract-plugin
export default {"peliculasGrid":"PeliculasGrid_peliculasGrid__dJ50Q"};